import { render } from "./rank-management.vue?vue&type=template&id=ff898b42&scoped=true"
import script from "./rank-management.vue?vue&type=script&lang=js"
export * from "./rank-management.vue?vue&type=script&lang=js"

import "./rank-management.vue?vue&type=style&index=0&id=ff898b42&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff898b42"]])

export default __exports__